import { isExperimentEnabled } from '@atlaskit/platform-feature-experiments/is-experiment-enabled';
import { fetchProfileAaid } from '@atlassian/conversation-assistant-store/controllers/profile';
import { fetchPromptOfTheDay } from '@atlassian/rovo-prompt-of-the-day/client';

/**
 * Warms the shared prompt-of-the-day cache so the dynamic panel finds it filled when it opens.
 *
 * Safe to call on every hover: the client answers from memory, browser storage or an already-open
 * request before it spends a new one, and the profile lookup is memoized. Never rejects, since a
 * missed prefetch only means the panel asks for itself.
 */
export const prefetchPromptOfTheDay = async (): Promise<void> => {
	if (!isExperimentEnabled('rovo_generated_potd_in_dynamic_panel')) {
		return;
	}

	try {
		const accountId = await fetchProfileAaid();
		if (accountId) {
			await fetchPromptOfTheDay({ accountId });
		}
	} catch {
		// The profile request failed; the panel falls back to its own request.
	}
};
